/**
 * Removes all elements from `array` that `predicate` returns truthy.
 */
export const remove = <T>(
  array: Array<T>,
  predicate: (value: T, index: number, obj: Array<T>) => boolean,
): Array<T> => {
  const idx = array.findIndex(predicate);
  if (idx === -1) return [];
  return array.splice(idx, 1);
};
